/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import { Dimmer, Loader } from "semantic-ui-react";

const Logout: React.FC = () => {
  useEffect(() => {
    const unloadMenu = () => {
      const removeNode = (nodeName: string) => {
        const node = document.getElementById(nodeName);
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      };
      removeNode("ProtectMyAppMenuContainer");
      removeNode("ProtectMyAppMenu");
      removeNode("aspMenuStyle");
    };

    const signOut = async () => {
      await Auth.signOut();
    };

    signOut();
    unloadMenu();
    setTimeout(() => {
      if (process.env.REACT_APP_REDIRECT_TO_PLATFORM) {
        window.location.href = "/app-shield-management";
      } else {
        window.location.href = "/";
      }
    }, 100);
  }, []);

  return (
    <Dimmer active>
      <Loader active inverted size="large"></Loader>
    </Dimmer>
  );
};

export default Logout;
